import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQueryFactory from "../axiosBaseQuery.factory";
import { IInvoice, IInvoiceStatus } from "../../origin/invoiceApi/types";
import { IDataResponse } from "../../origin/types";
import { IUserAddress } from "../../../components/AddNewAddress/types";

const {api, axiosBaseQuery} = axiosBaseQueryFactory(process.env.REACT_APP_API_BASE_URL_ORIGIN);

const baseApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: "originApi",
  endpoints: (build) => ({
    getUserAddresses: build.query<IUserAddress[], { userId?: number }>({
      query: ({ userId }) => ({
        url: `addresses?userId=${userId}`,
        method: "get",
      }),
      providesTags: (result, error, { userId }) => [
        { type: "userAddresses", userId },
      ],
    }),
    uploadPhoto: build.mutation<undefined, FormData>({
      query: (formData) => ({
        url: "/photos/upload",
        method: "post",
        body: formData,
      }),
      invalidatesTags: ["storagePhotos"],
    }),
    getInvoicesRequests: build.query<
      IDataResponse<IInvoice>,
      {
        userId?: number;
        limit?: number;
        skip?: number;
        status?: IInvoiceStatus[];
      }
    >({
      query: ({ userId, limit = 100, skip = 0, status }) => ({
        url: `invoices?userId=${userId}&$limit=${limit} &$skip=${skip}${status ? status.map((item, index) => `&status[${index}]=${item}`).join("") : ""}`,
        method: "get",
      }),
      providesTags: ["userInvoices"],
      transformResponse: (response: IDataResponse<IInvoice>, meta, arg) =>
        response,
      transformErrorResponse: (response, meta, arg) => response,
    }),
  }),
  tagTypes: ["storagePhotos", "userAddresses", "userInvoices", "cards", "UserCustomFields"],
});

// `api` is the axios instance. `baseApi` is the RTK Query API, which uses the `api` instance.
export { api, baseApi };
